import React from "react";
import "./Gallery.css";
import { motion } from "framer-motion";
import img1 from "../../assets/images/gallery/phonemouse1new.PNG";
import img2 from "../../assets/images/gallery/phonemouse2new.PNG";
import img3 from "../../assets/images/gallery/phonemouse3new.PNG";
import img4 from "../../assets/images/gallery/phonemouse4new.PNG";

const images = [img2, img4, img3, img1];

const imageVariants = {
  hidden: { opacity: 0, y: -50 },
  visible: (index) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: index * 0.15, ease: "easeOut" },
  }),
};

const Gallery = () => {
  return (
    <div className="image-container" style={{ marginTop: "100px", marginBottom: "100px" }}>
      {images.map((src, index) => (
        <motion.div
          key={index}
          className="iphone-frame"
          variants={imageVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.8, margin: "100px" }}
          custom={index}
        >
          <div className="iphone-notch"></div>
          <img
            src={src}
            alt={`Image ${index + 1}`}
            className="animated-image"
          />
        </motion.div>
      ))}
    </div>
  );
};

export default Gallery;
